import React, { useState, Fragment } from 'react';
import useSWR from 'swr';

const fetcher = url => {
    const token = localStorage.getItem('token');
    return fetch(url, { headers: { 'Authorization': `Bearer ${token}` } }).then(res => {
        if (res.status === 401) {
            localStorage.removeItem('token');
            localStorage.removeItem('user');
            window.location.href = '/login';
            throw new Error('Oturum süresi doldu.');
        }
        if (!res.ok) throw new Error('Sunucuya ulaşılamadı.');
        return res.json();
    });
};

const istek = async (url, method = 'POST', body) => {
    const res = await fetch(url, {
        method,
        headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${localStorage.getItem('token')}` },
        body: body ? JSON.stringify(body) : undefined
    });
    const data = await res.json().catch(() => ({}));
    if (!res.ok && !data.talep) throw new Error(data.hata || 'Sunucu hatası.');
    return data;
};

const tarihYaz = (iso) => (iso ? new Date(iso).toLocaleDateString('tr-TR') : '-');
const tarihSaatYaz = (iso) => (iso ? new Date(iso).toLocaleString('tr-TR', { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' }) : '');

const talepIcerigi = (t) => {
    const d = t.detay || {};
    const turler = t.turler || [t.tur];
    const satirlar = [];
    if (turler.some(x => ['isim_adres', 'alici'].includes(x))) satirlar.push([d.yeni_ad_soyad, d.yeni_telefon].filter(Boolean).join(' · '));
    if (turler.some(x => ['isim_adres', 'adres'].includes(x))) satirlar.push(d.yeni_adres);
    if (turler.includes('odeme')) satirlar.push(d.islem === 'kaldir' ? 'Ödeme şartı kaldırılacak' : `${d.islem === 'degistir' ? 'Yeni tutar' : 'Eklenecek tutar'}: ${d.tutar} TL`);
    return satirlar.filter(Boolean).join('\n');
};

const butonStili = (renk = '#333', pasif = false) => ({
    fontSize: '12px', padding: '4px 10px', border: `1px solid ${renk === '#333' ? '#ccc' : renk}`, borderRadius: '4px',
    background: '#fff', color: renk, cursor: pasif ? 'not-allowed' : 'pointer', opacity: pasif ? 0.5 : 1,
    fontFamily: 'Poppins, sans-serif'
});

function TeslimatTalepleri() {
    const [seciliAy, setSeciliAy] = useState(() => {
        const s = new Date();
        return `${s.getFullYear()}-${String(s.getMonth() + 1).padStart(2, '0')}`;
    });
    const [acikTalepId, setAcikTalepId] = useState(null);
    const [islemde, setIslemde] = useState(null);

    const url = `/api/teslimat-talepleri?ay=${seciliAy}`;
    const { data, error, isLoading, mutate } = useSWR(url, fetcher, { refreshInterval: 60000 });
    const talepler = data?.talepler || [];

    const islemYap = async (anahtar, fn) => {
        if (islemde) return;
        setIslemde(anahtar);
        try {
            await fn();
            await mutate();
        } catch (err) {
            alert(`İşlem başarısız: ${err.message}`);
        } finally {
            setIslemde(null);
        }
    };

    const topluKontrol = () => islemYap('toplu', async () => {
        const sonuc = await istek('/api/teslimat-talepleri/kontrol');
        alert(`${sonuc.kontrol_edilen} açık talep kontrol edildi, ${sonuc.degisen} talepte değişiklik var.`);
    });

    const talepIslem = (t, islem) => {
        if (islem === 'iptal' && !window.confirm('Talep iptal edilecek. Emin misiniz?')) return;
        if (islem === 'hatirlat' && !window.confirm("PTT'ye hatırlatma maili gönderilecek. Emin misiniz?")) return;
        islemYap(t.id, async () => {
            const yollar = {
                kontrol: [`/api/teslimat-talepleri/${t.id}/kontrol`, 'POST'],
                gonder: [`/api/teslimat-talepleri/${t.id}/gonder`, 'POST'],
                hatirlat: [`/api/teslimat-talepleri/${t.id}/gonder`, 'POST'],
                iptal: [`/api/teslimat-talepleri/${t.id}/durum`, 'PUT', { durum: 'İptal' }]
            };
            const [u, method, body] = yollar[islem];
            const sonuc = await istek(u, method, body);
            if (sonuc.hata) alert(`Mail gönderilemedi: ${sonuc.hata}`);
        });
    };

    const renderDurum = (t) => {
        const islendi = t.islendi;
        return (
            <>
                <span style={{
                    display: 'inline-block', padding: '3px 10px', borderRadius: '12px', fontSize: '11px', fontWeight: '600',
                    ...(islendi
                        ? { background: '#d4edda', color: '#155724', border: '1px solid #c3e6cb' }
                        : { background: '#fff3cd', color: '#856404', border: '1px solid #ffeeba' })
                }} title={islendi && t.talimat_tarihi ? `Talimat: ${t.talimat_tarihi}` : 'Hareketlerde henüz talimat görülmedi'}>
                    {islendi ? 'İşlendi' : 'Beklemede'}
                </span>
                {t.durum === 'Gönderilemedi' && <div style={{ color: '#dc3545', fontSize: '11px', marginTop: '3px' }}>Mail gönderilemedi</div>}
                {t.durum === 'İptal' && <div style={{ color: '#6c757d', fontSize: '11px', marginTop: '3px' }}>İptal edildi</div>}
                {!islendi && t.hatirlatilmali && <div style={{ color: '#fd7e14', fontSize: '11px', marginTop: '3px' }}>Hatırlatılmalı</div>}
            </>
        );
    };

    const renderDetay = (t) => {
        const acik = ['Gönderilemedi', 'Gönderildi', 'İşleme Alındı'].includes(t.durum);
        const mesgul = islemde === t.id;
        return (
            <div style={{ display: 'flex', gap: '16px', flexWrap: 'wrap', fontSize: '12px' }}>
                <div style={{ flex: '2 1 380px' }}>
                    <div style={{ marginBottom: '4px' }}><strong>Konu:</strong> {t.konu}</div>
                    <pre style={{ margin: 0, background: '#fff', border: '1px solid #e3e3e3', borderRadius: '4px', padding: '8px', whiteSpace: 'pre-wrap', wordBreak: 'break-word', fontFamily: 'Poppins, sans-serif', fontSize: '12px', color: '#444' }}>{t.govde}</pre>
                </div>
                <div style={{ flex: '1 1 260px' }}>
                    <div><strong>Barkod:</strong> {t.barkod}</div>
                    <div><strong>Sipariş No:</strong> {t.siparis_no || '-'}</div>
                    <div><strong>Talep Nedeni:</strong> {t.kaynak === 'hata' ? 'Gönderim Hatası' : 'Müşteri Talebi'}</div>
                    {t.notlar && <div><strong>Özel Not:</strong> {t.notlar}</div>}
                    <div><strong>Oluşturan:</strong> {t.olusturan || '-'} · {tarihSaatYaz(t.olusturma_tarihi)}</div>
                    {t.mail_hata && t.durum === 'Gönderilemedi' && <div style={{ color: '#842029' }}><strong>Mail hatası:</strong> {t.mail_hata}</div>}
                    <div style={{ marginTop: '8px' }}>
                        {(t.gecmis || []).map((g, i) => (
                            <div key={i} style={{ fontSize: '11px', color: '#666', borderTop: i ? '1px dashed #e5e5e5' : 'none', padding: '2px 0' }}>
                                {tarihSaatYaz(g.tarih)} · {g.olay}{g.kisi ? ` (${g.kisi})` : ''}
                            </div>
                        ))}
                    </div>
                    {acik && (
                        <div style={{ display: 'flex', gap: '6px', flexWrap: 'wrap', marginTop: '10px' }}>
                            {t.durum === 'Gönderilemedi' ? (
                                <button type="button" disabled={mesgul} style={butonStili('#1565C0', mesgul)} onClick={() => talepIslem(t, 'gonder')}>Tekrar Gönder</button>
                            ) : (
                                <>
                                    <button type="button" disabled={mesgul} style={butonStili('#333', mesgul)} onClick={() => talepIslem(t, 'kontrol')}>Kontrol Et</button>
                                    {!t.islendi && <button type="button" disabled={mesgul} style={butonStili('#fd7e14', mesgul)} onClick={() => talepIslem(t, 'hatirlat')}>Hatırlat</button>}
                                </>
                            )}
                            <button type="button" disabled={mesgul} style={butonStili('#6c757d', mesgul)} onClick={() => talepIslem(t, 'iptal')}>İptal Et</button>
                            {mesgul && <span style={{ alignSelf: 'center', color: '#888', fontSize: '11px' }}>İşleniyor...</span>}
                        </div>
                    )}
                </div>
            </div>
        );
    };

    const hucre = { padding: '12px', verticalAlign: 'top' };

    return (
        <div style={{ background: '#F8F8F8', padding: '20px', borderRadius: '8px', height: 'calc(100vh - 110px)', display: 'flex', flexDirection: 'column', overflow: 'hidden', boxSizing: 'border-box', fontFamily: 'Poppins, sans-serif' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px', flexShrink: 0, gap: '10px', flexWrap: 'wrap' }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                    <label style={{ fontWeight: '500' }}>Ay Seçimi:</label>
                    <input type="month" value={seciliAy} onChange={(e) => { setSeciliAy(e.target.value); setAcikTalepId(null); }}
                        style={{ padding: '8px', border: '1px solid #ccc', borderRadius: '4px', fontFamily: 'Poppins, sans-serif' }} />
                    <span style={{ color: '#888', fontSize: '13px' }}>{talepler.length} talep</span>
                </div>
                <button type="button" onClick={topluKontrol} disabled={!!islemde}
                    style={{ padding: '8px 16px', background: '#fff', border: '1px solid #1565C0', color: '#1565C0', borderRadius: '4px', cursor: islemde ? 'not-allowed' : 'pointer', fontFamily: 'Poppins, sans-serif', fontWeight: '500' }}>
                    {islemde === 'toplu' ? 'Kontrol ediliyor...' : 'Hareketleri Kontrol Et'}
                </button>
            </div>

            {data && data.mail_ayarli === false && (
                <div style={{ background: '#fff3cd', border: '1px solid #ffc107', borderRadius: '4px', padding: '6px 10px', fontSize: '12px', marginBottom: '10px' }}>
                    Mail ayarı yapılmamış: talepler kaydedilir ama PTT'ye otomatik mail gitmez.
                </div>
            )}

            <style>{`
                .talep-satiri { transition: background-color 0.2s; cursor: pointer; }
                .talep-satiri:hover { background-color: #f1f8ff !important; }
            `}</style>

            {error ? (
                <div style={{ padding: '20px', color: 'red' }}>Veri yüklenirken hata oluştu: {error.message}</div>
            ) : isLoading ? (
                <div style={{ textAlign: 'center', padding: '40px' }}>Yükleniyor...</div>
            ) : talepler.length > 0 ? (
                <div style={{ flex: 1, overflowY: 'auto', border: '1px solid #eee', borderRadius: '8px', background: 'white' }}>
                    <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '13px' }}>
                        <thead style={{ position: 'sticky', top: 0, zIndex: 10 }}>
                            <tr style={{ background: '#E5E5E5', color: '#333', height: '40px' }}>
                                <th style={{ padding: '12px', textAlign: 'left', fontWeight: '500', width: '110px' }}>Sipariş Tarihi</th>
                                <th style={{ padding: '12px', textAlign: 'left', fontWeight: '500' }}>Ad Soyad</th>
                                <th style={{ padding: '12px', textAlign: 'left', fontWeight: '500' }}>Talep İçeriği</th>
                                <th style={{ padding: '12px', textAlign: 'center', fontWeight: '500', width: '120px' }}>Durum</th>
                                <th style={{ padding: '12px', textAlign: 'left', fontWeight: '500' }}>Son Hareket</th>
                            </tr>
                        </thead>
                        <tbody>
                            {talepler.map(t => (
                                <Fragment key={t.id}>
                                    <tr className="talep-satiri" style={{ borderBottom: '1px solid #eee', background: acikTalepId === t.id ? '#f1f8ff' : undefined }}
                                        onClick={() => setAcikTalepId(acikTalepId === t.id ? null : t.id)}>
                                        <td style={hucre}>{tarihYaz(t.siparis_tarihi)}</td>
                                        <td style={{ ...hucre, fontWeight: '500' }}>{t.musteri || '-'}</td>
                                        <td style={hucre}>
                                            <div style={{ fontWeight: '500' }}>{t.tur_adi}</div>
                                            {talepIcerigi(t) && <div style={{ color: '#777', fontSize: '12px', whiteSpace: 'pre-wrap' }}>{talepIcerigi(t)}</div>}
                                        </td>
                                        <td style={{ ...hucre, textAlign: 'center' }}>{renderDurum(t)}</td>
                                        <td style={{ ...hucre, color: '#555', fontSize: '12px' }}>{t.son_hareket || '-'}</td>
                                    </tr>
                                    {acikTalepId === t.id && (
                                        <tr>
                                            <td colSpan="5" style={{ padding: '15px', background: '#f8f9fa', borderBottom: '1px solid #dee2e6' }}>
                                                {renderDetay(t)}
                                            </td>
                                        </tr>
                                    )}
                                </Fragment>
                            ))}
                        </tbody>
                    </table>
                </div>
            ) : (
                <div style={{ textAlign: 'center', padding: '50px', color: '#666', fontStyle: 'italic' }}>
                    Bu ay için talimat talebi bulunmamaktadır.
                    <p style={{ fontSize: '12px', marginTop: '10px' }}>Talimatlar Sipariş Listesi'nde siparişin Talimat İşlemleri bölümünden oluşturulur.</p>
                </div>
            )}
        </div>
    );
}

export default TeslimatTalepleri;
